import React from "react"
import { LiveId, SpaceKey } from "popopo-msg"
import { useLivePowerSummaries } from "popopo-lib-front/firestore-access"
import { firestore } from "../../core"
import { SpinnerRow } from "../SpinnerRow"

interface SpaceLivePowerRankingProps {
  spaceKey: SpaceKey
  liveId: LiveId
}

export const SpaceLivePowerRanking: React.FC<SpaceLivePowerRankingProps> = ({ spaceKey, liveId }) => {
  const livePowerSummaries = useLivePowerSummaries(firestore, spaceKey, liveId, 30)

  if (livePowerSummaries === "loading") {
    return <SpinnerRow />
  }

  if (livePowerSummaries.length === 0) {
    return (
      <div className="text-center text-muted">
        まだパワーが送信されていません
      </div>
    )
  }

  return (
    <div className="d-flex flex-column gap-2">
      <div className="list-group">
        {livePowerSummaries.map((summary, index) => (
          <div key={summary.id} className="list-group-item d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center gap-2">
              <span className="badge bg-primary rounded-pill">{index + 1}</span>
              <div>
                <div className="fw-bold">{summary.user.name}</div>
              </div>
            </div>
            <div className="text-end">
              {summary.total_price}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
